// extracted by mini-css-extract-plugin
export default {"message":"Approval_message__32ryL","carNumber":"Approval_carNumber__29ZXN","container":"Approval_container__26aJM","main":"Approval_main__316ka","space":"Approval_space__2tGRO","centered":"Approval_centered__2Kg4F","approvalBtn":"Approval_approvalBtn__MvjyE","approvalMessage":"Approval_approvalMessage__9onzy","onlyMobile":"Approval_onlyMobile__3LFAV","onlyDesktop":"Approval_onlyDesktop__JuYTW"};
    if(module.hot) {
      // 1741870133776
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  